import { createContext } from "react";
export var DeviceApiContext = createContext(null);